var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerDoubleRightUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7629 1.46225C14.054 1.17925 14.5174 1.17925 14.8085 1.46225L20.5228 7.01781C20.8198 7.30655 20.8265 7.78138 20.5377 8.07836C20.249 8.37535 19.7742 8.38204 19.4772 8.0933L14.2857 3.04603L9.09424 8.0933C8.79725 8.38204 8.32242 8.37535 8.03368 8.07836C7.74494 7.78137 7.75163 7.30655 8.04862 7.01781L13.7629 1.46225Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7426 5.98276C13.8842 5.83412 14.0805 5.75 14.2857 5.75C14.491 5.75 14.6873 5.83412 14.8288 5.98276L20.5431 11.9828C20.75 12.2 20.8075 12.5197 20.6894 12.7954C20.5712 13.0712 20.3 13.25 20 13.25H15.0357V19C15.0357 21.0711 13.3568 22.75 11.2857 22.75H4C3.58579 22.75 3.25 22.4142 3.25 22C3.25 21.5858 3.58579 21.25 4 21.25H11.2857C12.5284 21.25 13.5357 20.2426 13.5357 19V13.25H8.57143C8.27141 13.25 8.00025 13.0712 7.88207 12.7954C7.76388 12.5197 7.82141 12.2 8.02832 11.9828L13.7426 5.98276Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerDoubleRightUp);
export default __webpack_public_path__ + "static/media/corner-double-right-up.3b7cec2208dd5fff8771516fe670e07f.svg";
export { ForwardRef as ReactComponent };